"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectPayerDesktop = void 0;
require("antd/lib/spin/style");
var _spin = _interopRequireDefault(require("antd/lib/spin"));
var _react = _interopRequireDefault(require("react"));
var _reactSelect = _interopRequireDefault(require("react-select"));
var _api = require("../api");
require("./SelectPayerDesktop.less");
var _lodash = require("lodash");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// @TarasGumenyuk 2023-01-23
// This is a boilerplate for future SelectPayerDesktop component, used in admin for the ClincianAvailabilityReport
// When the time comes, and we get an understanding how this should work/look on desktop from Design/UI perspective
// planning to re-factor SelectPayer components group to a single component, using more custom hooks
var SelectPayerDesktop = function SelectPayerDesktop(_ref) {
  var _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? 'Select payer(s)' : _ref$placeholder,
    fieldNameProp = _ref.fieldName,
    form = _ref.form,
    isMultiple = _ref.isMultiple;
  var _useInitialSortedAndG = (0, _api.useInitialSortedAndGroupedPayerOptions)(),
    groupedOptions = _useInitialSortedAndG.groupedOptions,
    payersLoading = _useInitialSortedAndG.payersLoading;
  var _useSelectPayerSeachS = (0, _api.useSelectPayerSeachState)(groupedOptions),
    searchOptions = _useSelectPayerSeachS.searchOptions,
    handleOptionsSearch = _useSelectPayerSeachS.handleOptionsSearch;
  var setFieldsValue = form.setFieldsValue;
  var fieldName = fieldNameProp ? fieldNameProp : isMultiple ? 'payerIds' : 'payerId';
  var handleOptionChange = function handleOptionChange(newValues, actionMeta) {
    var changedValues = {};
    if ((0, _lodash.isEmpty)(newValues) || actionMeta.action === 'clear') {
      changedValues[fieldName] = undefined;
      setFieldsValue(changedValues);
      return;
    }
    changedValues[fieldName] = isMultiple ? newValues.map(function (payer) {
      return payer.id;
    }) : newValues;
    setFieldsValue(changedValues);
  };
  return payersLoading ? /*#__PURE__*/_react.default.createElement(_spin.default, {
    spinning: true
  }) : /*#__PURE__*/_react.default.createElement(_reactSelect.default, {
    options: searchOptions || groupedOptions,
    className: "select-payer-desktop",
    classNamePrefix: "select-payer",
    placeholder: placeholder,
    onChange: handleOptionChange,
    onInputChange: handleOptionsSearch,
    components: {
      IndicatorSeparator: function IndicatorSeparator() {
        return null;
      }
    },
    isMulti: isMultiple
  });
};
exports.SelectPayerDesktop = SelectPayerDesktop;